module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "u-margin-top-30 u-margin-bottom-30"
  }, [_vm._v("\n        Losses for Care\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_c('control', {
    attrs: {
      "for": "future_loss_of_care",
      "label": "Would you like to make a claim for care?"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.futureLossOfCare),
      expression: "futureLossOfCare"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "future_loss_of_care",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.futureLossOfCare = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])])], 1)]), _vm._v(" "), (_vm.futureLossOfCare) ? _c('div', [_vm._l((_vm.care), function(period, periodIndex) {
    return _c('div', [_c('futureCarePeriod', {
      attrs: {
        "index": periodIndex,
        "care": period
      }
    })], 1)
  }), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--no-margin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addCare
    }
  }, [_vm._v("Add Care Period")])], 2) : _vm._e(), _vm._v(" "), (_vm.futureLossOfCare && _vm.futureLossOfCareValid) ? _c('div', [_c('div', {
    staticClass: "a-table a-table--short-no-style a-table--full-width u-margin-top-50"
  }, [_c('table', {
    staticClass: "a-table--full-width",
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.care), function(period) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(period.careStartDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(period.careEndDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(period.multiplicand)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(period.duration, 2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(period.multiplier, 2)))]), _vm._v(" "), _c('td', [_c('tr', [_c('td', {
      staticStyle: {
        "border": "none",
        "padding": "0px"
      }
    }, [_vm._v("\n                                " + _vm._s(_vm.currencyFormat(period.futureCareTotal)) + "\n                            ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "border": "none",
        "padding": "0 0 0 10px"
      }
    }, [_c('div', {
      on: {
        "click": function($event) {
          return _vm.toggleModal(period)
        }
      }
    }, [_c('icon-tooltip', {
      attrs: {
        "tooltip-name": 'calculation_' + _vm.uniqueId,
        "tooltip-text": "Click to view calculation",
        "side": "left",
        "text-width": "140",
        "icon-type": "formula"
      }
    })], 1)])])])])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', {
    staticClass: "a-table--grey"
  }, [_c('td', {
    staticClass: "u-text-right u-bold",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.currencyFormat(_vm.careTotal)))])])])])]), _vm._v(" "), _c('br')])]) : _vm._e(), _vm._v(" "), _c('modal', {
    attrs: {
      "name": 'calculation_' + _vm.uniqueId,
      "no-default-button": "true"
    }
  }, [_c('modal-content')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Date from")]), _vm._v(" "), _c('th', [_vm._v("Date to")]), _vm._v(" "), _c('th', [_vm._v("Multiplicand")]), _vm._v(" "), _c('th', [_vm._v("Duration (years)")]), _vm._v(" "), _c('th', [_vm._v("Multiplier")]), _vm._v(" "), _c('th', [_vm._v("Future Care Loss")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-14a5863a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/personal-injury-claims/steps/other-future-losses/FutureCare.vue
// module id = 1578
// module chunks = 0